import baseAPI from '@/api/base';
import {
  EditDonation,
  GetDonation,
  MoveDonationToFolder,
  MoveDonationsToFolder,
  RegisterDonation,
} from '@/dtos/donation.dto';
import {
  BULK_DELETE_DONATIONS_URL,
  BULK_MOVE_DONATIONS_TO_FOLDER_URL,
  DELETE_DONATION_URL,
  EDIT_DONATION_URL,
  GET_DONATION_URL,
  MOVE_DONATION_TO_FOLDER_URL,
  REGISTER_DONATION_URL,
  TOGGLE_DONATION_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Donation {
  static getDonations = async (
    getDonation: GetDonation
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_DONATION_URL, {
      params: getDonation,
    });
    console.log('response', response);
    return response;
  };

  static registerDonation = async (
    registerDonation: RegisterDonation
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_DONATION_URL,
      {
        ...registerDonation,
      }
    );
    console.log('response', response);
    return response;
  };

  static editDonation = async (
    editDonation: EditDonation
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_DONATION_URL,
      {
        ...editDonation,
      }
    );
    return response;
  };

  static toggleDonationIsActive = async (
    editDonation: EditDonation
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_DONATION_IS_ACTIVE_URL,
      {
        ...editDonation,
      }
    );
    return response;
  };

  static moveDonationToFolder = async (
    moveDonationToFolder: MoveDonationToFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      MOVE_DONATION_TO_FOLDER_URL,
      {
        ...moveDonationToFolder,
      }
    );
    return response;
  };

  static moveDonationsToFolder = async (
    payload: MoveDonationsToFolder
  ): Promise<AxiosResponse> => {
    return baseAPI.patch(BULK_MOVE_DONATIONS_TO_FOLDER_URL, payload);
  };

  static deleteDonation = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_DONATION_URL}/${id}`
    );
    return response;
  };

  static deleteDonations = async (
    ids: string[]
  ): Promise<AxiosResponse> => {
    return baseAPI.delete(BULK_DELETE_DONATIONS_URL, {
      data: { ids },
    });
  };
}

export default Donation;
